const statusPlaceholder = [
  {
    value: 'EDITABLE',
    label: 'Editable',
  },
  {
    value: 'SUBMITTED',
    label: 'Submitted',
  },
  {
    value: 'INSUBMISSION',
    label: 'In-Submission',
  },
  {
    value: 'CREATED',
    label: 'Created',
  },
  {
    value: 'EDITED',
    label: 'Edited',
  },
];
export default statusPlaceholder;
